import { render } from "./EmailLink.vue?vue&type=template&id=bf0e4a82"
import script from "./EmailLink.vue?vue&type=script&lang=js"
export * from "./EmailLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__